import { IUnsubscribePreferenceState } from '../../types/unsubscribePreference/unsubscribePreference.types';
import {
  GET_PUBLIC_UNSUBSCRIBE_GROUPS_REQUEST,
  GET_PUBLIC_UNSUBSCRIBE_GROUPS_SUCCESS,
  GET_PUBLIC_UNSUBSCRIBE_GROUPS_FAILURE,
  GET_UNSUBSCRIBE_PREFERENCE_REQUEST,
  GET_UNSUBSCRIBE_PREFERENCE_SUCCESS,
  GET_UNSUBSCRIBE_PREFERENCE_FAILURE,
  CREATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
  CREATE_UNSUBSCRIBE_PREFERENCE_SUCCESS,
  CREATE_UNSUBSCRIBE_PREFERENCE_FAILURE,
  UPDATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
  UPDATE_UNSUBSCRIBE_PREFERENCE_SUCCESS,
  UPDATE_UNSUBSCRIBE_PREFERENCE_FAILURE,
  CLEAR_UNSUBSCRIBE_PREFERENCES,
  CLEAR_UNSUBSCRIBE_PREFERENCE_STATUS,
  UnsubscribePreferenceActionTypes,
} from './unsubscribePreference.types';

const initialState: IUnsubscribePreferenceState = {
  unsubscribeGroups: [],
  preference: null,
  loading: false,
  error: null,
  success: false,
};

const unsubscribePreferenceReducer = (
  state = initialState,
  action: UnsubscribePreferenceActionTypes
): IUnsubscribePreferenceState => {
  switch (action.type) {
    case GET_PUBLIC_UNSUBSCRIBE_GROUPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PUBLIC_UNSUBSCRIBE_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        unsubscribeGroups: action.payload,
        error: null,
      };

    case GET_PUBLIC_UNSUBSCRIBE_GROUPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case GET_UNSUBSCRIBE_PREFERENCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_UNSUBSCRIBE_PREFERENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        preference: action.payload,
        error: null,
      };

    case GET_UNSUBSCRIBE_PREFERENCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case CREATE_UNSUBSCRIBE_PREFERENCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case CREATE_UNSUBSCRIBE_PREFERENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
      };

    case CREATE_UNSUBSCRIBE_PREFERENCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        success: false,
      };

    case UPDATE_UNSUBSCRIBE_PREFERENCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case UPDATE_UNSUBSCRIBE_PREFERENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
      };

    case UPDATE_UNSUBSCRIBE_PREFERENCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        success: false,
      };

    case CLEAR_UNSUBSCRIBE_PREFERENCES:
      return {
        ...initialState,
      };

    case CLEAR_UNSUBSCRIBE_PREFERENCE_STATUS:
      return {
        ...state,
        error: null,
        success: false,
      };

    default:
      return state;
  }
};

export default unsubscribePreferenceReducer;
